const initState = {
	loading: false,
};
const contactReducer = (state = initState, action) => {
	switch (action.type) {
            case 'CONTACT_LOADER':
			return {
				...state,
				loading: action.payload,
			};

		default:
			return {
				...state,
			};
	}
};
export default contactReducer;
